import React from 'react';
import PropTypes from 'prop-types';
import { setPropTypes, setDisplayName, compose, mapProps } from 'recompose';
import { map, compose as compose$1, join } from 'ramda';

var FontImporter = function FontImporter(_ref) {
  var children = _ref.children,
      css = _ref.css;

  /* eslint-disable react/no-danger */
  return React.createElement(
    'div',
    null,
    React.createElement('style', {
      dangerouslySetInnerHTML: {
        __html: css
      }
    }),
    children
  );
  /* eslint-enable react/no-danger */
};



var mapUrlsToImports = map(function (url) {
  return '@import url(\'' + url + '\');';
});

var mapImportsToCss = compose$1(join('\n'), mapUrlsToImports);

var enhance = compose(setDisplayName('FontImporter'), setPropTypes({
  children: PropTypes.node,
  urls: PropTypes.array.isRequired
}), mapProps(function (ownerProps) {
  return {
    children: ownerProps.children,
    css: mapImportsToCss(ownerProps.urls)
  };
}));

var FontImporter$1 = enhance(FontImporter);

export default FontImporter$1;
export { FontImporter$1 as FontImporter };
